export default __webpack_public_path__ + "static/media/score-mobile.1d9822ef.mp4";